import React from 'react';

import { flagStyles } from '../settings';

const SvgAZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-336px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAZ;
